import EditModalPage from '&/pages/app-pages/EditModalPage';

const APP_ROUTE_LIST = [
    { path: '/app/editModalPage', component: EditModalPage }, //图册
];
export default APP_ROUTE_LIST;
